import { observer } from "mobx-react-lite";

import { DefaultInput } from "src/components/DefaultExerciseAttributeInput";
import { HoursExerciseAttribute } from "src/components/HoursExerciseAttribute";
import { MinutesExerciseAttribute } from "src/components/MinutesExerciseAttribute";
import { TempoExerciseAttribute } from "src/components/TempoExerciseAttribute";
import { useWorkoutItemSetContext } from "src/workouts/WorkoutItemSetContext";

export const ExerciseAttributeInput = observer(
  function ExerciseAttributeInput() {
    const workoutItemSetContext = useWorkoutItemSetContext();

    switch (workoutItemSetContext.getType()) {
      case "MINUTES":
        return <MinutesExerciseAttribute />;
      case "HOURS":
        return <HoursExerciseAttribute />;
      case "TEMPO":
        return <TempoExerciseAttribute />;
      default:
        return <DefaultInput />;
    }
  },
);
